'use client';

import { css } from '@bts-web/utils-style-engine';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { TradeOperation } from '../../../trade/utils';
import { RegularBuy, RegularSell } from '../../../common/svgIcons';
import { OrderOperation } from '../../types';
import { Drawer } from '../../../common/components/Drawer';
import {
  ListCellsSelectionCheckmarkItem,
  ListCellsSelectionRoot,
} from '../../../common/components/ListCellsSelection';

export const iconContainerStyles = css({
  display: 'flex',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'brand.fill_primary',

  '& [data-element="icon"]': {
    color: 'brand.text_primary_inverted',
  },
});

interface OrderTypeDrawerProps {
  title: string;
  isDisabled?: boolean;
  onChangeOrderType?: (value: OrderOperation) => void;
}

const OrderTypeDrawer = ({
  title,
  isDisabled,
  onChangeOrderType,
}: OrderTypeDrawerProps) => {
  const { t } = useClientTranslation();

  return (
    <Drawer title={title as string}>
      <ListCellsSelectionRoot onValueChange={onChangeOrderType}>
        <ListCellsSelectionCheckmarkItem
          key={TradeOperation.buy}
          id={TradeOperation.buy}
          value={TradeOperation.buy.toUpperCase() as OrderOperation}
          label={t('stop_order_buy_title_@tenant')}
          subLabel={t('stop_order_buy_subtitle')}
          activeItemId=""
          icon={
            <div className={iconContainerStyles} data-element="icon">
              <RegularBuy />
            </div>
          }
        />
        <ListCellsSelectionCheckmarkItem
          key={TradeOperation.sell}
          id={TradeOperation.sell}
          value={TradeOperation.sell.toUpperCase() as OrderOperation}
          label={t('stop_order_sell_title_@tenant')}
          subLabel={t('stop_order_sell_subtitle')}
          isDisabled={isDisabled}
          activeItemId=""
          icon={
            <div className={iconContainerStyles} data-element="icon">
              <RegularSell />
            </div>
          }
        />
      </ListCellsSelectionRoot>
    </Drawer>
  );
};

export { OrderTypeDrawer };
